<div class="form-api-validation-errors">
  <mat-list *ngFor="let item of errors | keyvalue">
    <h3 matSubheader>{{ item.key | uppercase }}</h3>
    <mat-list-item *ngFor="let message of item.value">
      {{ message }}
    </mat-list-item>
  </mat-list>
</div>
